var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-item" },
    [
      _vm.hasRendererFunction
        ? _c("cell-renderer", { attrs: { column: _vm.column, data: _vm.data } })
        : _vm.hasRendererComponent
        ? [
            _c(_vm.column.cellRenderer, {
              tag: "component",
              attrs: { column: _vm.column, data: _vm.data }
            })
          ]
        : [_vm._v(" " + _vm._s(_vm.value) + " ")]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }